// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function QuickViewMediaDetails(Props) {
  var media = Props.media;
  var activeMediaChild = Props.activeMediaChild;
  var productsInMedia = Props.productsInMedia;
  var match = ConfigurationProvider$Showside.use(undefined);
  var openLinkInNewTab = match.config.settings.openLinkInNewTab;
  EntrypointContext$Showside.use(undefined);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$1.goTo;
  var defaultDescriptionExpanded = productsInMedia.length === 0 && media.pins.length === 0;
  var match$2 = React.useState(function () {
    return defaultDescriptionExpanded;
  });
  var setDescriptionExpanded = match$2[1];
  var descriptionExpanded = match$2[0];
  var link = Belt_Option.keep(Belt_Option.orElse(activeMediaChild.link, media.link), Category$Showside.Link.isNotEmpty);
  React.useEffect(function () {
    Curry._1(setDescriptionExpanded, function (param) {
      return defaultDescriptionExpanded;
    });
  }, [media.id]);
  var renderTitle = function (param) {
    return Belt_Option.mapWithDefault(Belt_Option.keep(media.title, function (title) {
      return media.showTitle;
    }), null, function (title) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("text-2xl font-semibold text-primary")
      }, title);
    });
  };
  var renderHTML = function (text) {
    if (text === "") {
      return null;
    } else {
      return React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: text.replace(/\\\r/g, "\r").replace(/\\\n/g, "\n").replace(/\\\t/g, "\t")
        }
      });
    }
  };
  var renderDescription = function (param) {
    return Belt_Option.mapWithDefault(media.description, null, function (description) {
      return React.createElement("div", {
        className: CSS$Showside.prefix(descriptionExpanded ? "select-text" : "cursor-pointer select-none"),
        onClick: function (param) {
          Curry._1(setDescriptionExpanded, function (param) {
            return true;
          });
        }
      }, React.createElement(DynamicTruncate$Showside.make, {
        lines: descriptionExpanded ? -1 : 6,
        className: CSS$Showside.prefix("inline text-xl text-primary whitespace-pre-wrap"),
        dataTestId: "qv-media-description",
        children: renderHTML(description)
      }));
    });
  };
  var renderLink = function (param) {
    var icon = React.createElement(Unicons$Showside.UilLinkAlt.make, {
      size: /* Px */{
        _0: 18
      }
    });
    return Belt_Option.mapWithDefault(link, null, function (link) {
      var onClick;
      switch (link.TAG | 0) {
        case /* URL */0:
          onClick = undefined;
          break;
        case /* Category */1:
          var match = link._0;
          var filters = match.filters;
          var categoryId = match.categoryId;
          onClick = function (e) {
            Curry._3(goTo, undefined, undefined, {
              TAG: /* ListPage */1,
              _0: {
                listPageType: {
                  TAG: /* Category */0,
                  _0: categoryId
                },
                viewPLP: false,
                filters: filters,
                sort: undefined
              }
            });
          };
          break;
        case /* Product */2:
          var match$1 = link._0;
          var productCategoryId = match$1.productCategoryId;
          var variantId = match$1.variantId;
          var productId = match$1.productId;
          onClick = function (e) {
            Curry._3(goTo, undefined, undefined, {
              TAG: /* PDP */2,
              _0: {
                categoryId: productCategoryId,
                productCategoryId: productCategoryId,
                productId: productId,
                variantId: variantId,
                zoomedPhotoIndex: undefined
              }
            });
          };
          break;
        case /* StoreCategory */3:
          var match$2 = link._0;
          var sortBy = match$2.sortBy;
          var categoryId$1 = match$2.categoryId;
          onClick = function (e) {
            Curry._3(goTo, undefined, undefined, {
              TAG: /* ListPage */1,
              _0: {
                listPageType: {
                  TAG: /* StoreCategory */2,
                  _0: {
                    categoryId: categoryId$1,
                    sourceNodeId: media.id
                  }
                },
                viewPLP: false,
                filters: undefined,
                sort: sortBy
              }
            });
          };
          break;
        case /* CustomAction */4:
          var match$3 = link._0;
          var name = match$3.name;
          var code = match$3.code;
          onClick = function (e) {
            CustomScript$Showside.triggerCustomFunctionWithoutProducts(code, name, undefined, undefined);
          };
          break;
      }
      var href;
      href = link.TAG === /* URL */0 ? link._0 : undefined;
      var tmp = {
        children: React.createElement("div", {
          className: CSS$Showside.prefix("flex items-center justify-center space-x-2 text-lg -my-2 -mx-3 py-2 px-3")
        }, icon, React.createElement("div", undefined, "Learn More")),
        openLinkInNewTab: openLinkInNewTab
      };
      if (href !== undefined) {
        tmp.href = Caml_option.valFromOption(href);
      }
      if (onClick !== undefined) {
        tmp.onClick = Caml_option.valFromOption(onClick);
      }
      return React.createElement("div", {
        className: CSS$Showside.prefix("inline-block pt-4")
      }, React.createElement(Link$Showside.make, tmp));
    });
  };
  var match$3 = media.title;
  var match$4 = media.description;
  if (match$3 === undefined && match$4 === undefined && link === undefined) {
    return null;
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("flex flex-col space-y-4")
  }, renderTitle(undefined), renderDescription(undefined), renderLink(undefined), productsInMedia.length !== 0 ? React.createElement("div", {
    className: CSS$Showside.prefix("border-b border-primary opacity-5 pt-2")
  }) : null);
}
QuickViewMediaDetails.displayName = "QuickViewMediaDetails";
var make = QuickViewMediaDetails;
export { make };
/* react Not a pure module */